/* The Cabin Six Two-Tier, страница по болям (27.09.2026): увеличение фото и страниц мануала, лента этапов на телефоне. */
(function(){
  if(window.__whS6) return; window.__whS6=1;
  var lb=null, list=[], at=0;
  function el(){
    if(lb) return lb;
    lb=document.createElement('div'); lb.className='s6-lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true'); lb.setAttribute('aria-label','Enlarged picture');
    lb.innerHTML='<figure class="s6-lb__f"><img alt=""><figcaption class="s6-lb__c"></figcaption></figure>'+
      '<button type="button" class="s6-lb__p" aria-label="Previous">&larr;</button><button type="button" class="s6-lb__n" aria-label="Next">&rarr;</button>'+
      '<button type="button" class="s6-lb__x" aria-label="Close">&times;</button>';
    lb.addEventListener('click',function(e){
      if(e.target.closest('.s6-lb__x')||e.target===lb) return close();
      if(e.target.closest('.s6-lb__p')) return go(-1);
      if(e.target.closest('.s6-lb__n')) return go(1);
    });
    /* свайп в увеличенном виде (телефон) */
    var x0=null; lb.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
    lb.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; x0=null; if(Math.abs(dx)>40) go(dx<0?1:-1); },{passive:true});
    return lb;
  }
  function paint(){
    var l=el(), it=list[at]||['',''];
    var img=l.querySelector('img'); img.src=it[0]; img.alt=it[1]||'';
    l.querySelector('.s6-lb__c').textContent=(list.length>1?(at+1)+' of '+list.length+' · ':'')+(it[1]||'');
    l.querySelector('.s6-lb__p').hidden=list.length<2; l.querySelector('.s6-lb__n').hidden=list.length<2;
  }
  function open(items,i){
    list=items; at=i||0; var l=el(); paint();
    if(!l.parentNode) document.body.appendChild(l);
    document.documentElement.style.overflow='hidden'; document.documentElement.classList.add('s6-lb-open');
    requestAnimationFrame(function(){ l.classList.add('on'); l.querySelector('.s6-lb__x').focus({preventScroll:true}); });
  }
  function close(){
    if(!lb||!lb.parentNode) return;
    lb.classList.remove('on'); document.documentElement.style.overflow=''; document.documentElement.classList.remove('s6-lb-open');
    setTimeout(function(){ if(lb&&lb.parentNode&&!lb.classList.contains('on')) lb.parentNode.removeChild(lb); },200);
  }
  function go(d){ if(list.length<2) return; at=(at+d+list.length)%list.length; paint(); }
  /* телефон: второстепенные карточки — строками, раскрываются по нажатию */
  function fold(){
    if(!window.matchMedia||!window.matchMedia('(max-width:767px)').matches) return;
    document.querySelectorAll('[data-s6fold]').forEach(function(x){
      if(x.parentNode&&x.parentNode.classList&&x.parentNode.classList.contains('s6-fd')) return;
      var d=document.createElement('details'), s=document.createElement('summary');
      d.className='s6-fd s6-card'; s.textContent=x.getAttribute('data-s6fold'); d.appendChild(s);
      x.parentNode.insertBefore(d,x); d.appendChild(x); x.classList.add('s6-fd__b');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fold); else fold();
  document.addEventListener('keydown',function(e){
    if(!lb||!lb.parentNode) return;
    if(e.key==='Escape') close(); else if(e.key==='ArrowLeft') go(-1); else if(e.key==='ArrowRight') go(1);
  });
  document.addEventListener('click',function(e){
    var f=e.target.closest&&e.target.closest('.s6-ph[data-s6z]');
    if(f){ e.preventDefault();
      /* 29.09 (Алекс: «в увеличенном виде не листаются»): кадр из ленты комнаты — открываем всю ленту с этого кадра */
      var strip=f.closest('[data-s6rs-t]');
      if(strip){ var sl=[].slice.call(strip.querySelectorAll('.s6-ph[data-s6z]')); open(sl.map(function(x){ return [x.getAttribute('data-s6z'),x.getAttribute('data-cap')||'']; }),Math.max(0,sl.indexOf(f))); return; }
      open([[f.getAttribute('data-s6z'),f.getAttribute('data-cap')||'']],0); return; }
    var b=e.target.closest&&e.target.closest('.s6-stage__b[data-s6pages]');
    if(b){ e.preventDefault(); try{ open(JSON.parse(b.getAttribute('data-s6pages')),0); }catch(_){} return; }
    var cp=e.target.closest&&e.target.closest('[data-s6copy]');
    if(cp){ var box=cp.closest('[data-s6show]'), ul=box&&box.querySelector('.s6-show'); if(!ul) return;
      var txt=[].map.call(ul.querySelectorAll('li'),function(x){return '- '+x.textContent.trim();}).join('\n');
      var done=function(){ var sp=cp.querySelector('span:last-child'); cp.classList.add('is-done'); if(sp){ var o=sp.textContent; sp.textContent='Copied'; setTimeout(function(){ sp.textContent=o; cp.classList.remove('is-done'); },1800);} };
      if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done,function(){}); return; }
    var n=e.target.closest&&e.target.closest('[data-s6prev],[data-s6next]');
    if(n){
      var sec=n.closest('.s6'), strip=sec&&sec.querySelector('[data-s6strip]'); if(!strip) return;
      var card=strip.querySelector('.s6-stage'), w=card?card.getBoundingClientRect().width+10:280;
      strip.scrollBy({left:(n.hasAttribute('data-s6next')?1:-1)*w,behavior:'smooth'});
    }
  });
})();
